import React, { useState } from "react";
import {
  Layout,
  Input,
  Button,
  Form,
  Space,
  theme,
  Row,
  Col,
  Breadcrumb,
  notification,
  Typography
} from "antd";
import { AlertError, AlertSuccess } from '../usableclasses.js';
import { useNavigate } from "react-router-dom";
import Headerdiv from "../layout/header";
import Footerdiv from "../layout/footer";
import { KeyOutlined } from "@ant-design/icons";
import axios from "axios";
import { MAINAPIURL,APPBACKGROUND_COLOR } from '../appsettings.js';


const ChangeMyPassword = () => {
  
const { Content } = Layout;

    const {
    token: { colorBgContainer, borderRadiusLG },
  } = theme.useToken();

  const [loading, setLoading] = useState(false);
  const [addForm] = Form.useForm();
  const navigate = useNavigate();

  const ApiURL = MAINAPIURL;
  const TOKEN = localStorage.getItem("AUTHCODE");
  const UPDATED_BY = localStorage.getItem("USERID");

  const handleAdd = async (values) => {
    
    if(values.txtoldpassword.trim() === "" || values.txtoldpassword.trim() === null)
    {
        notification.error({
            message: "Error",
            description: "please enter your current password.",
            });
        return;
    }

    if(values.txtnewpassword.trim() === "" || values.txtnewpassword.trim() === null)
    {
        notification.error({
            message: "Error",
            description: "please enter your new password.",
            });
        return;
    }

    if(values.txtrenewpassword.trim() === "" || values.txtrenewpassword.trim() === null)
    {
        notification.error({
            message: "Error",
            description: "please Re-enter your new password.",
            });
        return;
    }

    if(values.txtnewpassword.trim().length < 6)
    {
        notification.error({
            message: "Error",
            description: "At leaset 6 characters need for your new password",
            });
        return;
    }

    var regularExpression = /^(?=.*[0-9])(?=.*[a-zA-Z])[a-zA-Z0-9]{6,15}$/;

    if(!regularExpression.test(values.txtnewpassword.trim()))
    {
        notification.error({
            message: "Error",
            description: "password should contain atleast one number and one alphabet letter, only numbers and alphabet letters are allowed",
            });
        return;
    }

    if(values.txtnewpassword.trim() !== values.txtrenewpassword.trim())
    {
        notification.error({
            message: "Error",
            description: "Your re-entered password is did not match with new password",
            });
        return;
    }

   
      setLoading(true);
      const requestData = {
            userId: UPDATED_BY,
            oldPassword: values.txtoldpassword.trim(),
            newPassword: values.txtnewpassword.trim(),
        };

        try {
            const response = await axios.post(`${ApiURL}/auth/changepassword`, requestData, {
                headers: { SystemAccessToken: TOKEN },
            });

            if (response.status === 200) {
                
              if(response.data == true)
              {
                AlertSuccess("Password Updated.");
                navigate(`/login`);
              }
              else
              {
                AlertError("Failed to update your password");
              }
                
             
            }
        } catch (error) {
            AlertError("Failed to update your password");
        }
  };


  return (
    <Layout style={{backgroundColor: APPBACKGROUND_COLOR}}>
      <Headerdiv />
      <Content style={{ padding: '10px', }} >
        <Breadcrumb style={{ margin: "16px 0" }}>
          <Breadcrumb.Item>Password Change</Breadcrumb.Item>
        </Breadcrumb>
        <div
          style={{
            padding: 10,
            minHeight: "65vh",
            background: colorBgContainer,
            borderRadius: borderRadiusLG,
          }}
        >
          <Space
            direction="vertical"
            style={{ width: "100%", padding: "15px" }}
          >
            <Row gutter={[16, 16]} style={{ width: "100%", border: "1px solid #ddd", padding: "0 16px", alignContent: "" }}>
              <Col xs={24} md={8} >

                <Form
                  form={addForm}
                  layout="vertical"
                  onFinish={handleAdd}
                  style={{ width: "100%" }}
                >
                  <Typography.Title level={5} style={{ fontSize: "14px", padding: "0 0 5px 0" }}>Change My Password</Typography.Title>

                  <Row gutter={[16, 16]} style={{ rowGap: "0", justifyContent: "space-between" }}>
                    <Col xs={24} md={24}>
                      <Row xs={24} md={24}>
                        <Col xs={24} md={24} style={{ padding: "0 5px 0 5px" }}>
                          <Form.Item
                            label="Your Current Password"
                            name="txtoldpassword"
                            rules={[{ required: true, message: "Please Enter Your Current Password" }]}
                          >
                            <Input
                              maxLength={15}
                              placeholder="Current Password"
                              style={{ width: "100%", margin: "0" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={24} style={{ padding: "0 5px 0 5px",color:"blue" }}>
                        <p>1. Character Count : minimum 6 and maximum 15</p>
                        <p>2. Character Type : Numbers and Alphabet letters only Allowed</p>
                        <p>3. Password need at least one number and one alphabet letter</p>
                        </Col>
                        <Col xs={24} md={24} style={{ padding: "0 5px 0 5px" }}>
                          <Form.Item
                            label="Your New Password"
                            name="txtnewpassword"
                            rules={[{ required: true, message: "Please Enter Your New Password" }]}
                          >
                            <Input
                              maxLength={15}
                              placeholder="New Password"
                              style={{ width: "100%", margin: "0" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={24} style={{ padding: "0 5px 0 5px" }}>
                          <Form.Item
                            label="Your New Password"
                            name="txtrenewpassword"
                            rules={[{ required: true, message: "Please Re-enter Your New Password" }]}
                          >
                            <Input
                              maxLength={15}
                              placeholder="Re-enter New Password"
                              style={{ width: "100%", margin: "0" }}
                            />
                          </Form.Item>
                        </Col>
                        <Col xs={24} md={24} style={{ padding: "0 5px 0 5px" }}>
                            <Form.Item>
                            <Button
                              type="primary"
                              htmlType="submit"
                              icon={<KeyOutlined />}
                              loading={loading}
                              style={{ width: "100%", margin: "0" }}
                            >
                              Update Password
                            </Button>
                          </Form.Item>
                        </Col>
                      </Row>
                      
                    </Col>
                  </Row>
                </Form>
              </Col>
            </Row>
            
          </Space>
        </div>
        
      </Content>
      <Footerdiv />

    </Layout>
  );
};

export default ChangeMyPassword;